// extracted by mini-css-extract-plugin
export var cardHeader = "_g4-0";
export var reorderHandle = "_g4-3";
export var titleArea = "_g4-1";
export var titleAreaWithHandle = "_g4-2";